import { Box, Checkbox, Grid, Input, Text, TextInput } from "@dehub/theme";
import type { UseFormReturnType } from "@dehub/theme";
import { UserIcon } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import type { IFormData } from "./register-form";
import classes from "./register-form.module.css";

type Props = {
  form: UseFormReturnType<IFormData>;
};

export function RegisterFormFinanceSection({ form }: Props) {
  const { t } = useTranslation("register");
  const isManager = form.values.dehubFinanceIsManager;
  const inputClass = isManager ? classes.inputDisabled : classes.input;

  return (
    <Grid.Col span={12}>
      <Box className={classes.sectionHeader}>
        <Box className={classes.sectionIcon}>
          <UserIcon size={18} />
        </Box>
        <Text className={classes.sectionTitle}>{t("form.financeStaff")}</Text>
      </Box>
      <Grid gap="md">
        <Grid.Col span={12}>
          <Input.Wrapper labelProps={{ fw: "normal", mb: "xs", fz: "md" }}>
            <Checkbox label={t("form.ownFinance")} {...form.getInputProps("dehubFinanceIsManager", { type: "checkbox" })} />
          </Input.Wrapper>
        </Grid.Col>
        <Grid.Col span={{ base: 12, sm: 6 }}>
          <TextInput
            classNames={{
              root: classes.root,
              input: inputClass,
              label: classes.label,
            }}
            label={t("form.lastName")}
            placeholder={t("form.lastNamePlaceholder")}
            withAsterisk={!isManager}
            disabled={isManager}
            {...form.getInputProps("dehubFinance.lastName")}
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, sm: 6 }}>
          <TextInput
            classNames={{
              root: classes.root,
              input: inputClass,
              label: classes.label,
            }}
            placeholder={t("form.firstNamePlaceholder")}
            label={t("form.firstName")}
            withAsterisk={!isManager}
            disabled={isManager}
            {...form.getInputProps("dehubFinance.firstName")}
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, sm: 6 }}>
          <TextInput
            classNames={{
              root: classes.root,
              input: inputClass,
              label: classes.label,
            }}
            placeholder={t("form.emailAddressPlaceholder")}
            label={t("form.emailAddress")}
            withAsterisk={!isManager}
            disabled={isManager}
            {...form.getInputProps("dehubFinance.email")}
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, sm: 6 }}>
          <TextInput
            classNames={{
              root: classes.root,
              input: inputClass,
              label: classes.label,
            }}
            inputMode="numeric"
            maxLength={8}
            placeholder={t("form.phonePlaceholder")}
            label={t("form.phone")}
            withAsterisk={!isManager}
            disabled={isManager}
            {...form.getInputProps("dehubFinance.phone")}
            onChange={(e) => form.setFieldValue("dehubFinance.phone", e.currentTarget.value.replace(/\D/g, "").slice(0, 8))}
          />
        </Grid.Col>
      </Grid>
    </Grid.Col>
  );
}
